/**
 * NotificationEmptyState Component
 *
 * Displays a friendly empty state when there are no notifications.
 */

import styles from './NotificationDropdown.module.css';

export function NotificationEmptyState() {
  return (
    <div className={styles.emptyState}>
      <div className={styles.emptyIcon}>
        <svg
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
          <path d="M13.73 21a2 2 0 0 1-3.46 0" />
        </svg>
      </div>
      <p className={styles.emptyTitle}>No notifications</p>
      <p className={styles.emptyMessage}>You're all caught up!</p>
    </div>
  );
}
